// src/screens/admin/reports/Reports.js
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Container, Row, Col, Card, Button, Form, Table, Badge, Spinner } from 'react-bootstrap';
import AdminLayout from '../../../layouts/admin/adminlayout/AdminLayout';
import '../../../assets/css/admin/reports/Reports.css';
import axios from 'axios';
import AppContext from '../../../context/AppContext';
import * as XLSX from 'xlsx';
import { useReactToPrint } from 'react-to-print';


const Reports = () => {
  const [dateRange, setDateRange] = useState('thisMonth');
  const [studentReport, setStudentReport] = useState([]);
  const [loadingReport, setLoadingReport] = useState(true);
  const tableRef = useRef(null);
  const { baseUrl } = useContext(AppContext);
  const reportCards = [
    {
      id: 1,
      title: 'Student Activity Report',
      description: 'Track student engagement and participation',
      icon: '👨‍🎓',
      color: 'blue',
      records: 2847
    },
    {
      id: 2,
      title: 'Study Groups Analytics',
      description: 'Performance metrics of all study groups',
      icon: '📊',
      color: 'green',
      records: 156
    },
    {
      id: 3,
      title: 'File Downloads Report',
      description: 'Track file downloads and popular content',
      icon: '📥',
      color: 'purple',
      records: 1230
    },
    {
      id: 4,
      title: 'Revenue Report',
      description: 'Financial overview and subscription data',
      icon: '💰',
      color: 'orange',
      records: 45820
    }
  ];

  const handlePrint = useReactToPrint({
    contentRef:tableRef,
    documentTitle: "Student Activity Report",
    onAfterPrint: () => console.log("Print success!"),
  });


  const studentActivityReport = () => {
    axios.post(`${baseUrl}/admin/reports/studentActivityReport`)
      .then((response) => {
        console.log('Report generated successfully:', response.data);
        setStudentReport(response.data.students);
        setTimeout(() => {
          setLoadingReport(false);
        }, 1000);

      })
      .catch((error) => {
        console.error('Error generating report:', error);
      })


  }
  useEffect(() => {
    studentActivityReport();
  }, []);

  return (
    <AdminLayout>
      {loadingReport ? <div className="d-flex justify-content-center align-items-center" style={{ height: '80vh' }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div> :
        <div className="reports-page">
          {/* Page Header */}
          <div className="page-header mb-4">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h2 className="page-title">
                  <span className="page-icon">📈</span>
                  Reports & Analytics
                </h2>
                <p className="text-muted">Generate and view comprehensive reports</p>
              </div>
          
            </div>
          </div>



          {/* Recent Reports Table */}
          <Card>
            <Card.Header>
              <h5 className="mb-0">Student Report</h5>
            </Card.Header>
            <Card.Body>
              <Table ref={tableRef} hover responsive>
                <thead>
                  <tr>
                    <th>Student Id</th>
                    <th>Student Name</th>
                    <th>Study Groups</th>
                    <th>Study Sessions</th>
                    <th>Flash Cards</th>
                    <th>Participations</th>
                  </tr>
                </thead>
                <tbody>
                  {studentReport.map((report) => (
                    <tr key={report.id}>
                      <td className="fw-bold">{report.id}</td>
                      <td>{report.fullname}</td>
                      <td>{
                        report.chstudygroups.map((group) => {
                          return <>
                            <br />
                            <div className='badge bg-primary' key={group.id}>{group.groupName}</div>
                          </>
                        })
                      }</td>
                      <td>{
                        report.chstudysessions.map((session) => {
                          return <>
                            <br />
                            <div className='badge bg-primary' key={session.id}>{session.sessionTitle}</div>
                          </>
                        })
                      }</td>
                      <td>{
                        report.chflashcarddecks.map((deck) => {
                          return <>
                            <br />
                            <div className='badge bg-primary' key={deck.id}>{deck.deckName}</div>
                          </>
                        })
                      }

                      </td>
                      <td>{
                        <div className='badge bg-primary'>{report.chconversations.length}</div>
                        
                      }

                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>

          {/* Export Options */}
          <Card className="mt-4">
            <Card.Header>
              <h5 className="mb-0">Export Options</h5>
            </Card.Header>
            <Card.Body>
              <Row>
               
                <Col md={4} className="mb-3">
                  <Button onClick={()=>{
                    const wb = XLSX.utils.table_to_book(tableRef.current);
                    XLSX.writeFile(wb, "StudentActivityReport.xlsx");
                  }} variant="outline-success" className="w-100">
                    <i className="bi bi-file-excel"></i> Export as Excel
                  </Button>
                </Col>
                <Col md={4} className="mb-3">
                  <Button onClick={()=>{
                    const wb = XLSX.utils.table_to_book(tableRef.current);
                    XLSX.writeFile(wb, "StudentActivityReport.csv");
                  }} variant="outline-info" className="w-100">
                    <i className="bi bi-file-text"></i> Export as CSV
                  </Button>
                </Col>
                <Col md={4} className="mb-3">
                  <Button onClick={()=>{
                    handlePrint();
                  }} variant="outline-warning" className="w-100">
                    <i className="bi bi-printer"></i> Print Report
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </div>
      }
    </AdminLayout>
  );
};

export default Reports;